import { client } from 'shared';

export function markNotWorked(id: number) {
    const requestBody = {
        business_closed_not_worked: new Date().toISOString(),
    };
    return client(`api/hour-report/${id}/`, { body: requestBody, method: 'PATCH' });
}
